export default "__VITE_ASSET__55Hi5KI1__"